
import { MapLocation } from '@/types/location';

// 9Round Female Gym Locations
export const nineRoundFemaleGyms: MapLocation[] = [
  {
    id: 8001,
    name: "9Round - Riyadh (AL Mathar Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.681617855093904, 46.66770080417996],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8002,
    name: "9Round - Riyadh (Al Rawabi Exit 15 Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.695222934697952, 46.79715153461494],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8003,
    name: "9Round - Riyadh (Al Rabwa Exit 14 Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.696271372003302, 46.77210829140578],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8004,
    name: "9Round - Riyadh (Al Waha Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.747405547765922, 46.723327781071646],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8005,
    name: "9Round - Riyadh (Al Nakhil Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.741389018904744, 46.61925147697249],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8006,
    name: "9Round - Riyadh (Al Nasim Sharqi Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.7469804876356, 46.823649928825546],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8007,
    name: "9Round - Riyadh (Al Khaleej Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.75666241464621, 46.791069723323],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8008,
    name: "9Round - Riyadh (Olaya Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.704873244043576, 46.67931045215832],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8009,
    name: "9Round - Riyadh (Al Rawda Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.728545894711672, 46.76720914782216],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8010,
    name: "9Round - Riyadh (Al Nahda Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.75673578494619, 46.79095072024109],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8011,
    name: "9Round - Riyadh (Al Tawun Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.772639435570998, 46.69729386441765],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8012,
    name: "9Round - Riyadh (Al Yasmin Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.818958318556735, 46.64431108527122],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8013,
    name: "9Round - Riyadh (Al Qurtubah Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.802921417421654, 46.73826938434274],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8014,
    name: "9Round - Riyadh (Munsiyah Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.8217225109855, 46.773145713376906],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8015,
    name: "9Round - Riyadh (Hittin Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.768830363256306, 46.58836122066549],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8016,
    name: "9Round - Riyadh (Al Laban Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.618714207912504, 46.54348171959933],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8017,
    name: "9Round - Riyadh (Al Qarwan Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.825143214193453, 46.5652474625607],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8018,
    name: "9Round - Riyadh (Al Yarmuk Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.795908543823643, 46.77525722024108],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8019,
    name: "9Round - Riyadh (Al Raed Adbullah Rd Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.711377014791353, 46.63162866441766],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8020,
    name: "9Round - Riyadh (Al Nada Female)",
    type: "Gym",
    devices: 1,
    coordinates: [24.80709325920825, 46.69429660990132],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8021,
    name: "9Round - Riyadh (Al Rabwa Kids)",
    type: "Gym",
    devices: 1,
    coordinates: [24.692343858135708, 46.764931046033546],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Kids",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8022,
    name: "9Round - Jeddah (Al Samer Female)",
    type: "Gym",
    devices: 1,
    coordinates: [21.585099745048932, 39.227609216944636],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8023,
    name: "9Round - Jeddah (Al Naeem Female)",
    type: "Gym",
    devices: 1,
    coordinates: [21.64333096904803, 39.140898057709684],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8024,
    name: "9Round - Jeddah (Al Shamaliyah Female)",
    type: "Gym",
    devices: 1,
    coordinates: [21.76008564743449, 39.118047706747035],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8025,
    name: "9Round - Jeddah (Al Rawda Female)",
    type: "Gym",
    devices: 1,
    coordinates: [21.568378297629405, 39.16919565092359],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8026,
    name: "9Round - Jeddah (Al Hamadaniyyah Female)",
    type: "Gym",
    devices: 1,
    coordinates: [21.786598516797874, 39.20734301454287],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8027,
    name: "9Round - Khobar (Rakah Female)",
    type: "Gym",
    devices: 1,
    coordinates: [26.365329629013864, 50.206760070581495],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 8028,
    name: "9Round - Dammam (Al Faisaliah Female)",
    type: "Gym",
    devices: 1,
    coordinates: [26.39811970610452, 50.046608947229196],
    region: "Eastern",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "20-45",
    orientation: "Landscape",
    segment: "Fitness"
  }
];
